import { useState } from "react"
import {
    Box,
    Button,
    Card,
    CardContent,
    TextField,
    Typography,
    Alert,
    CircularProgress
} from "@mui/material"
import { deleteUserAccount, signin2 } from "../services/api"
import { useParams } from "react-router-dom"

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const DeleteUser = () => {
    const { appId } = useParams()

    const [accessToken, setAccessToken] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const [creds, setCreds] = useState({
        username: "",
        password: ""
    })

    const handleChangeCreds = (e) => {
        setError("")
        setCreds(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const login = async () => {
        if (!creds.username || !creds.password) {
            setError("Username and password are required")
            return
        }

        setLoading(true)
        try {
            const response = await signin2({
                username: emailRegex.test(creds.username)
                    ? creds.username
                    : "+91" + creds.username,
                password: creds.password,
                appId
            })

            setAccessToken(response?.data?.accessToken)
        } catch (err) {
            setError("Invalid credentials")
        } finally {
            setLoading(false)
        }
    }

    const deleteAccount = async () => {
        setLoading(true)
        try {
            let resp = await deleteUserAccount(accessToken)
            if(resp?.status === 200) {
                alert("Account Deleted Successfully")
                setAccessToken()
            }
        } catch (err) {
            setError("Failed to delete account")
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f5f7fa"
        >
            <Card sx={{ width: 380, borderRadius: 3, boxShadow: 4 }}>
                <CardContent>
                    <Typography variant="h6" mb={2} textAlign="center">
                        {accessToken ? "Delete Account" : "Login to Continue"}
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    {!accessToken ? (
                        <>
                            <TextField
                                fullWidth
                                label="Email or Phone"
                                name="username"
                                value={creds.username}
                                onChange={handleChangeCreds}
                                margin="normal"
                            />

                            <TextField
                                fullWidth
                                label="Password"
                                name="password"
                                type="password"
                                value={creds.password}
                                onChange={handleChangeCreds}
                                margin="normal"
                            />

                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 2 }}
                                onClick={login}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={22} /> : "Login"}
                            </Button>
                        </>
                    ) : (
                        <>
                            <Alert severity="warning" sx={{ mb: 2 }}>
                                This action is irreversible. Your account will be permanently deleted.
                            </Alert>

                            <Button
                                fullWidth
                                variant="contained"
                                color="error"
                                onClick={deleteAccount}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={22} /> : "Delete Account"}
                            </Button>
                        </>
                    )}
                </CardContent>
            </Card>
        </Box>
    )
}

export default DeleteUser
